import { getStorage, connectStorageEmulator } from "firebase/storage"

import { app } from ".."

export const storage = getStorage(app)

if (process.env.REACT_APP_FIREBASE_EMULATION_MODE === "EMULATION") {
  connectStorageEmulator(storage, "localhost", 9199)
}
